import { Add, AddToPhotos, Delete } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import * as Sentry from '@sentry/react';
import { Col, Progress, Row } from 'antd';
import { DeleteModal } from "components/Dialog";
import MultiFileUploader from "components/UI/admin/MultifileUploadGallery";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import React, { useEffect, useState } from 'react';
import { FileUploader } from "react-drag-drop-files";
import styled from 'styled-components';
import COLOR from "utils/constants/color";
import { UPLOAD_IMAGE_TO_FIREBASE , IMAGE_FILE_TYPE } from 'utils/constants/enum';
import { imageUploader } from 'utils/methods/imageUploader';
const ImageContainer = styled.div`
    height: auto;
    flex: 1;
    height:70vh;
    // display: flex;
    margin-right:10px;
`;

const Images = styled.img`
    background-color: ${COLOR.white};
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    border-radius:8px;
`;

const Container = styled.div`
    width: 100%;
    height: 100%;
    display:flex;
    align-item:center;
    justify-content:center;
    position: relative;
    background-color:${p => p.empty ? "rgba(0,0,0,0.1)" : "transparent"}
`;

const FileUploadArea = styled.div`
    height: 100%;
    border: 1px dashed gray;
    padding: 5px 12px;
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const Text = styled.div`
    font-size: 12px;
`;
const Column = styled(Col)`
display: flex;
    justify-content: center;
    align-items: center;
}
`

const ImageWrapper = styled.div`
    border: 1px dashed;
    padding: 10px;
    border-radius: 8px;
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f9f9f9;
`;

const initialImages = [{ sequence: 1, resource: null, description: '', pageId: '' }];

export default function AnswerPages({ onChange, style, pageId, path, data, onDelete, onAutoScroll = () => null, setUpdateLoader = () => { }, updateLoader = false, errorImg = false, setErrorImg, loaderImg, setLoaderImg, actionButtonText="Add Answer" }) {
    const showAlert = useAlert();
    const [deleteModal, setDeleteModal] = useState(false)
    const [loader, setLoader] = useState(false);
    const [loaderSecond, setLoaderSecond] = useState(false);
    const [updateIndex, setUpdateIndex] = useState(-1);
    const [loadingProgress, setLoadingProgress] = useState(0);
    const [loadingMapSecond, setLoadingMapSecond] = useState(0);
    const [AnswerData, setAnswerData] = useState({});
    const [images, setImages] = useState(initialImages);
    const [prevData, setPrevData] = useState(null);

    useEffect(() => {
        // Check if the data has changed
        if (JSON.stringify(data) !== JSON.stringify(prevData)) {    
            if (data?.length > 0) {
                let maxSeq = Math.max(...data.map(k => k.sequence || 1)) || 1;
                let item = data.map((k, i) => {
                    if (!k.sequence) {
                        k.sequence = maxSeq + 1;
                        maxSeq += 1;
                    }
                    return k;
                });
                    setImages(item);
            } else {
                setImages(initialImages);
            }
        setPrevData(data);
        setLoaderImg(false)
        setUpdateIndex(-1)
        }
    }, [data, prevData,images]);

    useEffect(()=>{
        if(errorImg){
            setLoaderImg(false)
            setErrorImg(false)
        }
    },[errorImg])
    
    const onAddAnswer = () => {
        let maxSeq = Math.max(...images.map(k => k.sequence || 1)) || 1
        const addNew = {
            resource: null,
            description: '',
            pageId: '',
            sequence: maxSeq +1
        }
        const newImages = [...images, addNew];
        setImages(newImages);
        onAutoScroll();
    }

    const handleChange = (file, sequence, index) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
    
        // Upload the file to storage
        uploadToStorage(file, pageId, sequence, index);
    
        // Remove any blank objects (where `resource` is null or empty)
        reader.onloadend = function (e) {
            const updatedImages = images.map(img =>
                img.sequence === sequence ? { ...img, resource: reader.result } : img
            );
            let filteredImages = updatedImages.filter(img => img.resource); // Filter out blank objects

            setImages(filteredImages);
        };
    };
    
    const onSelectImage = async (url, sequence, index) => {
        const updatedImages = images.map(img =>
            img.sequence === sequence ? { ...img, resource: url } : img
        );
        setImages(updatedImages);
        setLoader(prev => ({ ...prev, [sequence]: false }));
        setLoadingProgress(prev => ({ ...prev, [sequence]: 0 }));
        setUpdateLoader(false);
        onChange({ url: url, pageId, sequence: sequence });
        showAlert("Uploaded successfully!", 'success')
    }

    const uploadToStorage = async (file, index, sequence,indexxx) => {
        if (file) {
            try {
                setLoaderImg(true)
                setUpdateIndex(indexxx)
                showAlert("Uploading..", "info")
                const onProgress = (per) =>{
                    setLoadingProgress(prev => ({ ...prev, [sequence]: per }));
                    setLoader(prev => ({ ...prev, [sequence]: true }));
                    setUpdateLoader(true);
                };
                const downloadURL = await imageUploader(file,onProgress,UPLOAD_IMAGE_TO_FIREBASE)
                if(downloadURL){
                    setLoader(prev => ({ ...prev, [sequence]: false }));
                    setLoadingProgress(prev => ({ ...prev, [sequence]: 0 }));
                    setUpdateLoader(false);
                    onChange({ url: downloadURL, pageId: index, sequence: sequence });
                    showAlert("Uploaded successfully!", 'success')
                }else{
                    setLoaderImg(false)
                    setLoader(prev => ({ ...prev, [sequence]: false }));
                    setLoadingProgress(prev => ({ ...prev, [sequence]: 0 }));
                    showAlert("Something went wrong!", 'error')
                }
            } catch (error) {
                Sentry.captureException(`Error in uploadToStorage: ${error}`);
                console.error("Upload error:", error);
            } finally{
                setLoaderImg(false)
                setLoader(prev => ({ ...prev, [sequence]: false }));
                setLoadingProgress(prev => ({ ...prev, [sequence]: 0 }));
            }
        } else {
            console.log("No file to upload.");
        }
    };
    // const uploadToStorage = async (file, index, sequence,indexxx) => {
    //     if (file) {
    //         const location = path || '/books/pages';
    //         const id = `${moment().format('YYYY-MM-DD')}-${v4()}${file.name}`;
    //         const fileRef = fireRef(storage, `${location}/${id}`);

    //         try {
    //             setLoaderImg(true)
    //             setUpdateIndex(indexxx)
    //             const uploadTask = uploadBytesResumable(fileRef, file);
    //             uploadTask.on('state_changed',
    //                 (snapshot) => {
    //                     const per = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
    //                     setLoadingProgress(prev => ({ ...prev, [sequence]: per }));
    //                     setLoader(prev => ({ ...prev, [sequence]: true }));
    //                     setUpdateLoader(true);
    //                 },
    //                 (error) => {
    //                     console.error("Upload error:", error);
    //                     setLoaderImg(false)
    //                     setLoader(prev => ({ ...prev, [sequence]: false }));
    //                     setLoadingProgress(prev => ({ ...prev, [sequence]: 0 }));
    //                 },
    //                 () => {
    //                     getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
    //                         setLoader(prev => ({ ...prev, [sequence]: false }));
    //                         setLoadingProgress(prev => ({ ...prev, [sequence]: 0 }));
    //                         setUpdateLoader(false);
    //                         onChange({ url: downloadURL, pageId: index, sequence: sequence });
    //                     });
    //                 }
    //             );
    //         } catch (error) {
    //             console.error("Upload error:", error);
    //             setLoaderImg(false)
    //             setLoader(prev => ({ ...prev, [sequence]: false }));
    //             setLoadingProgress(prev => ({ ...prev, [sequence]: 0 }));
    //         }
    //     } else {
    //         console.log("No file to upload.");
    //     }
    // };

    const canAddMoreImages = images.every(img => img.resource);

    return (
        <>
        <Button
            variant="contained"
            color="primary"
            startIcon={<Add />}
            onClick={onAddAnswer}
            disabled={!canAddMoreImages || updateLoader}
            style={{ marginBottom: 5 }}
        >
            {actionButtonText}
        </Button>
        <ImageContainer onContextMenu={(e) => { }} style={style}>
            <DeleteModal deleteToggle={deleteModal} onDelete={() => {
                let filteredImages = images.filter(img => img.resource); 
                setImages(filteredImages)
                setDeleteModal(false);
                onDelete(filteredImages, AnswerData);  
            }}
                setDeleteToggle={setDeleteModal}
                message={`Are you sure you want to remove this answer page?`}
            />
            {images.map((image, index) => {
                const pagePoster = image?.resource || null;
                return (
                    <ImageWrapper key={index}>
                        {image.resource && (
                            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                                <IconButton
                                    onClick={() => {
                                        setDeleteModal(true);
                                        setAnswerData(index);
                                    }}
                                    style={{ padding: 0 }}
                                >
                                    <Delete color="secondary" />
                                </IconButton>
                            </div>
                        )}
                        <Container empty={!pagePoster}>
                            <Images src={pagePoster} />
                        </Container>
                        <MultiFileUploader inModal onSelect={v=>{
                            onSelectImage(v, image?.sequence, index)
                        }}/>
                        <FileUploader
                            classes={"file-uploader-cover answerFileUploader"}
                            handleChange={(file) => handleChange(file, image?.sequence, index)}
                            name="file"
                            types={IMAGE_FILE_TYPE}
                            disabled={loaderImg}
                        >
                            <FileUploadArea>
                                {loader[image.sequence] && <Progress type="line" percent={loadingProgress[image.sequence]} size={"small"} className={"fileProgress"} showInfo={false} />}
                                <Row className="box box-1" style={{ display: "flex", justifyContent: "space-between" }}>
                                    <Column>
                                        <AddToPhotos color="primary" />
                                    </Column>
                                    <Column>
                                        <Text>
                                            Upload or drop a file right here
                                        </Text>
                                    </Column>
                                    <Column>
                                        <Text>
                                            {IMAGE_FILE_TYPE.join(",")}
                                        </Text>
                                    </Column>
                                </Row>
                            </FileUploadArea>
                        </FileUploader>
                    </ImageWrapper>
                );
            })}
        </ImageContainer>
        </>
    )
}